// Préparer un e-mail dans la messagerie choisie par l'utilisateur
// (préférence gardée sur cet appareil).
export const MESSAGERIES = [
  { id: "app", label: "Logiciel de messagerie (Outlook classique, Mail…)" },
  { id: "outlook365", label: "Outlook sur le web (Microsoft 365, pro)" },
  { id: "outlook", label: "Outlook.com (Hotmail, Live)" },
  { id: "gmail", label: "Gmail" },
];
const CLE = "preference-messagerie";

export function messageriePreferee() {
  try { return localStorage.getItem(CLE) || "app"; } catch { return "app"; }
}
export function choisirMessagerie(id) {
  try { localStorage.setItem(CLE, id); } catch { /* stockage indisponible */ }
}

export function lienMail({ to = "", subject = "", body = "" }, mode = messageriePreferee()) {
  const e = encodeURIComponent;
  switch (mode) {
    case "outlook365": return `https://outlook.office.com/mail/deeplink/compose?to=${e(to)}&subject=${e(subject)}&body=${e(body)}`;
    case "outlook": return `https://outlook.live.com/mail/0/deeplink/compose?to=${e(to)}&subject=${e(subject)}&body=${e(body)}`;
    case "gmail": return `https://mail.google.com/mail/?view=cm&fs=1&to=${e(to)}&su=${e(subject)}&body=${e(body)}`;
    default: return `mailto:${e(to)}?subject=${e(subject)}&body=${e(body)}`;
  }
}

export function ouvrirMail(msg, mode = messageriePreferee()) {
  const url = lienMail(msg, mode);
  if (mode === "app") window.location.href = url;
  else window.open(url, "_blank", "noopener");
}
